import { NavLink } from "react-router";

import { useEffect } from "react";
import ReactDOMServer from 'react-dom/server'


import $ from 'jquery';
import Loader from "../components/Loader";
import VaultList, {initVaultList} from "../components/VaultList";
import appAjax from "../helpers/ajax";

import ModalOpenVault, {initModalOpenVault} from "../modals/openvault";

function ListVault() {
    const doLoadList = (page) => {
        var url = appAjax.utilBaseUrl+'/?p=api&act=list_vault&page='+page+'&limit=50';
        appAjax._ajax_send(null, {
            type: 'GET',
            beforeSend: function() {
                $('.page_loader').show();
                $('.vault_list_container').html('');
                $('.vault_list_stats').html('');
            },
            success: function(response) {
                const htmlString = ReactDOMServer.renderToStaticMarkup(<VaultList vaults={response.data} page={page}/>);

                var newElmt = $(htmlString).html(); // get the inner HTML of the new element
                $('.vault_list_container').html(newElmt);

                var targetDom = $('.vault_list_container').get(0);

                initVaultList(targetDom, {
                    openVault(vaultData) {
                        //-- Show modal
                        var modal = $('#web_modal_unlockvault');
                        initModalOpenVault(modal, vaultData);
                        $(modal).modal('show', { backdrop: 'static', keyboard: false });
                    }
                });

                $('.vault_list_stats').text('Count: ' + response.count);
            },
            error: function(response) {
                $('.vault_list_container').html('<tr><td colspan="2" class="text-danger" style="text-align: center;">'+response.message+'</td></tr>');
            },
            always: function() {
                $('.page_loader').hide();
            }
        }, 'Loading vaults...', url);
    };

    const onLoad = () => {
        doLoadList(1);
        
        $('.btn_createvault').off('click').on('click', function (e) {
            e.preventDefault();
            var modal = $('#web_modal_unlockvault');
            initModalOpenVault(modal, null);
            $(modal).modal('show', { backdrop: 'static', keyboard: false });
        });

        var windowHeight = $(window).height();
        $('#web_vaultlist_container').css('height', (windowHeight - 100) +'px');
    };

    const onSaved = () => {
        doLoadList(1);
    };

    const onCreated = (vaultData) => {
        doLoadList(1);
    };

    useEffect(() => {
        onLoad();
        
        return () => {
        
        }
    }, []);

    return (
        <div className="container" style={{ paddingTop: '15px' }}>
            <div className="row">
                <div className="col-lg-8 offset-lg-2">

                    <div className="card">
                        <div className="card-header">
                            <NavLink to="/"><i className="fa fa-chevron-left"></i> Back</NavLink>
                            <span className="ml-3">
                                <i className="fa fa-archive"></i> <strong>Vaults</strong> <span className="val_appver"></span>
                            </span>
                        </div>
                        <div className="card-body" id="web_vaultlist_container" style={{ minHeight: '300px', overflowY: 'auto' }}>
                            <div className="mb-3">
                                <a href="#" className="btn btn-primary btn-sm btn_createvault">
                                    <i className="fa fa-plus"></i> Create Vault
                                </a>
                            </div>

                            <div className="table-responsive">
                                <table className="table table-striped table-hover table-sm" style={{ fontSize: '0.9rem' }}>
                                    <thead>
                                        <tr>
                                            <th scope="col">Vault</th>
                                            <th scope="col" style={{ textAlign: "right" }}>Last Updated</th>
                                        </tr>
                                    </thead>
                                    <tbody className="vault_list_container">
                                        
                                    </tbody>
                                </table>
                            </div>

                            <p className="vault_list_stats" style={{fontSize: '10pt'}}></p>

                            <div className="page_loader" style={{ textAlign: "center", padding: 10 }}>
                                <Loader label="Loading vaults..." />
                            </div>

                        </div>
                    </div>

                </div>
            </div>
            
            <ModalOpenVault onSaved={onSaved} onCreated={onCreated} />
        </div>
    );
}

export default ListVault;
